<template>
  <section class="cart-table">
    <div class="cart-table-wrap content">
      <ul>
        <li class="header ou-flex-center">
          <div v-show="type === 'cart'" class="goods-check">
            <el-checkbox
              :indeterminate="isIndeterminate"
              :disabled="!getCartNum"
              v-model="isAllCheck"
              >全选</el-checkbox
            >
          </div>
          <div class="goods-info">
            <div class="goods-cover"></div>
            <div class="goods-name">商品信息</div>
          </div>
          <div class="goods-price ou-expand">
            {{ type === "cart" ? "售价" : "原价" }}
          </div>
          <div v-show="type === 'cart'" class="goods-action ou-expand">
            操作
          </div>
          <div v-show="type === 'preOrder'" class="goods-action ou-expand">
            售价
          </div>
        </li>
        <div>
          <cart-item
            v-for="(item, index) in goodsList"
            :key="index"
            :itemData="item"
            :itemIndex="index"
            :type="type"
          ></cart-item>
        </div>
        <div v-if="type === 'cart' && getCartNum === 0">
          <no-data />
          <!-- <el-empty description="暂无商品">
            <el-button class="empty-link" type="primary" @click="goBookStore">去逛逛</el-button>
          </el-empty> -->
          <div class="ou-flex-center ou-padding-md">
            <el-button class="empty-link" type="primary" @click="goBookStore"
              >去逛逛</el-button
            >
          </div>
        </div>

        <li v-show="type === 'cart'" class="bottom-bar">
          <div class="goods-check">
            <el-checkbox
              :indeterminate="isIndeterminate"
              :disabled="!getCartNum"
              v-model="isAllCheck"
              >全选</el-checkbox
            >
          </div>
          <div class="goods-bat-del">
            <el-button
              type="text"
              class="ou-btn-text"
              icon="el-icon-delete"
              @click="deleteSelectedItems"
              >移除</el-button
            >
          </div>
          <div class="goods-num ou-expand">
            已选择 <span style="color: #ff5353">{{ getCheckNum }}</span> 件商品
          </div>
          <div class="goods-total ou-expand">
            合计: <span class="price-span">{{ getTotalPrice }}</span>
          </div>
          <div class="goods-action ou-expand">
            <el-button @click="goPreOrder" class="order-btn">结算</el-button>
          </div>
        </li>
        <li v-show="type === 'preOrder'" class="bottom-bar order">
          <div>
            <div class="inline-box">
              <div class="goods-total ou-expand">
                实付:
                <span class="price-span">{{ totalPrice | paymentText }}</span>
              </div>
              <div class="goods-action ou-expand">
                <el-button @click="$emit('handlePay')" class="order-btn"
                  >去付款</el-button
                >
              </div>
            </div>
            <div class="ou-text-tips">温馨提示：此类商品不支持退换货</div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiCreateOrder } from "@/api/user/order";
import { apiBatDeleteCartItems } from "@/api/cart/cart";
import { SelGoodsStatus } from "@/api/bookstore/bookstore";
import NoData from "@/components/noData.vue";
import CartItem from "../CartItem";
export default {
  name: "CartTable",
  components: { CartItem, NoData },
  props: {
    type: { type: String, default: "preOrder" },
    totalPrice: { type: Number, default: 0 },
    goodsList: { type: Array, default: () => [] },
  },
  data() {
    return {
      delConfirmVisible: false,
    };
  },

  watch: {},
  computed: {
    ...mapGetters([
      "getCartNum",
      "getCheckNum",
      "getTotalPrice",
      "getIsAllCheck",
      "getCheckGoods",
      "userId",
    ]),
    isAllCheck: {
      get() {
        return !!this.getCartNum && this.getIsAllCheck;
      },
      set(val) {
        this.checkAll(val);
      },
    },
    isIndeterminate() {
      return this.getCheckNum !== 0 && !this.getIsAllCheck;
    },
  },
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    goBookStore() {
      this.$router.push("/bookstore/index");
    },
    goPreOrder() {
      let state = "正常";
      if (this.getCheckNum === 0) {
        this.$message.error("请至少选择一件商品");
        return;
      }
      for (let i = 0; i < this.getCheckGoods.length; i++) {
        SelGoodsStatus(this.getCheckGoods[i].goodsId).then((res) => {
          if (res.data.status != 2) {
            this.$message(this.getCheckGoods[i].goodsTitle + "已下架");
            state = "已下架";
            return;
          }
        });
      }
      setTimeout(() => {
        if (state == "正常") {
          this.$router.push({
            path: "/submitOrder/index",
            query: { from: "cart" },
          });
        }
      }, 500);
    },
    deleteSelectedItems() {
      let goods = this.getCheckGoods;
      if (!goods.length) {
        this.$message.error("尚未选择任何商品");
        return;
      }
      this.$confirm(
        `确定要移除已勾选的${this.getCheckNum}件商品吗？`,
        "系统提示",
        {
          type: "warning",
        }
      ).then(() => {
        let list = [];
        goods.forEach((item) => list.push(item.id));
        apiBatDeleteCartItems({ ids: list.join(",") }).then((res) => {
          console.log("批量移除购物车商品返回", res);
          this.$store.dispatch("GetShoppingCart").then(() => {
            this.$message.success("移除成功");
          });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* 购物车主要内容区CSS */
.cart-table-wrap.content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  height: auto;
  background-color: #fffefd;
  ul ::v-deep {
    background-color: #fffefd;
    color: #424242;
    line-height: 52px;
    .header {
      height: 52px;
      padding: 0 20px;
      color: #424242;
      border-bottom: 1px solid #f2f2f2;
    }
    .goods-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      padding: 20px;
      height: 130px;
      .goods-info {
        display: flex;
        .goods-cover {
          height: 90px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            margin: 0 auto;
          }
          .el-image__error {
            width: 90px;
            height: 90px;
            text-align: center;
            line-height: 90px;
            border-radius: 8px;
          }
        }
        .goods-name {
          line-height: 32px;
          flex: 1;
          span {
            cursor: pointer;
            &:hover {
              color: #2e9adb;
            }
          }
        }
      }
      .el-checkbox {
        font-size: 16px;
        margin-left: 24px;
      }
    }
    .empty-link {
      width: 100px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      padding: 0;
      background: #2e9adb;
      border-radius: 6px;
    }
    .bottom-bar {
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid #f2f2f2;
      &.order {
        height: 135px;
        padding: 0 40px;
        justify-content: flex-end;
        .inline-box {
          text-align: right;
          line-height: 40px;
          & > div {
            display: inline-block;
          }
          .goods-total {
            font-size: 14px;
            margin-right: 20px;
            .price-span {
              margin-left: 12px;
            }
          }
          .order-btn {
            height: 40px;
          }
        }
        .ou-text-tips {
          line-height: 24px;
        }
      }
    }
    .goods-check {
      width: 80px;
    }
    .goods-info {
      width: 48%;
      min-width: 480px;
      div {
        display: inline-block;
      }
      .goods-cover {
        width: 110px;
        img {
          width: 90px;
          height: 90px;
        }
      }
      .goods-name {
        padding-left: 32px;
      }
    }
    .goods-bat-del {
      width: 52%;
      padding-left: 18px;
    }
    .goods-price,
    .goods-num,
    .goods-total {
      text-align: center;
    }
    .goods-action {
      text-align: center;
      .order-btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        color: #ffffff;
        padding: 0;
        background: #2e9adb;
        border-radius: 6px;
      }
    }
    .price-span {
      font-size: 18px;
      font-weight: 400;
      color: #ff5353;
      &::before {
        content: "¥";
      }
      &.origin {
        margin-left: 16px;
        font-size: 14px;
        color: #b6b6b6;
        text-decoration: line-through;
      }
      &.narmal {
        color: #666666;
      }
    }
  }
}
</style>
